import { get } from "lodash";
import { RichText } from "prismic-reactjs";
import useResponsive from "../hooks/useResponsive";
import styled from "styled-components";

// Styled Components
const StlSection = styled.section`
  min-height: 520px;
  margin-top: 78px;
  width: 100%;
  background: ${(props) => `url(${props.$bg}) center / cover no-repeat`};

  @media (min-width: 601px) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

const StlContent = styled.div`
  color: white;
  display: grid;
  gap: 16px;
  text-align: center;
  padding: 100px 16px 32px;

  h1,
  h4 {
    font-family: "Gotham Medium";
  }

  @media (min-width: 601px) {
    max-width: 50%;
    text-align: left;
    padding: 32px 16px;
  }

  @media (min-width: 1024px) {
    padding-left: 65px;
  }
`;

const Hero = (slice) => {
  const { isMobile } = useResponsive();
  const backgroundImage = isMobile
    ? get(slice, "primary.mobile_image.url")
    : get(slice, "primary.desktop_image.url");
  return (
    <StlSection $bg={backgroundImage}>
      <StlContent>
        <RichText render={get(slice, "primary.copy")} />
      </StlContent>
    </StlSection>
  );
};

export default Hero;
